export const Option1ActionTypes = {
    FETCH_OPTION_HEAD_1_START: "FETCH_OPTION_HEAD_1_START",
}
export const Option2ActionTypes  = {
    FETCH_OPTION_HEAD_2_START: "FETCH_OPTION_HEAD_2_START",
}
export const Option3ActionTypes  = {
    FETCH_OPTION_HEAD_3_START: "FETCH_OPTION_HEAD_3_START",
}
export const Option4ActionTypes  = {
    FETCH_OPTION_HEAD_4_START: "FETCH_OPTION_HEAD_4_START",
}